import { ConfigurationModel } from '../../models';

export abstract class IConfigurationService {
    abstract getConfiguration(): Promise<ConfigurationModel>;
}
